import http_request from './http_request'
import config from 'config'

async function startSession(id) {
	return http_request.post(`${config.whiteboard_api_gateway}sessions/${encodeURIComponent(id)}`)
		.withExternalJwt()
		.send()
}

async function getSession(id) {
	return http_request.get(`${config.whiteboard_api_gateway}sessions/${encodeURIComponent(id)}`)
		.withExternalJwt()
		.send()
}

function findSessionByPhoenixSessionId(id) {
	// TODO: find why I can't send the id as part of the payload
	return http_request.get(
		`${config.whiteboard_api_gateway}sessions?phoenixSessionId=${id}`
	)
		.withExternalJwt()
		.send()
}

async function startDrawing(data) {
	return http_request.post(`${config.whiteboard_api_gateway}drawings`)
		.withExternalJwt()
		.send(data)
}

async function getDrawing(id) {
	return http_request.get(`${config.whiteboard_api_gateway}drawings/${encodeURIComponent(id)}`)
		.withExternalJwt()
		.send()
}

async function findDrawingBySession(data) {
	return http_request.get(`${config.whiteboard_api_gateway}drawings
		?sessionId=${encodeURIComponent(data.sessionId)}
		&mode=${data.mode}
		&slideId=${data.slideId}`)
		.withExternalJwt()
		.send()
}

async function ping() {
	return http_request.get(`${config.whiteboard_api_gateway}sessions/ping`)
		.withExternalJwt()
		.send()
}

export {
	startSession,
	getSession,
	getDrawing,
	startDrawing,
	findSessionByPhoenixSessionId,
	findDrawingBySession,
	ping,
}
